import { useEffect } from "react";
import OrganisationForm from "./organisationForm";
import { useUser } from "@/hooks/useUser";
import { useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";
import Loader from "@/components/common/Loader";
function Organisation() {
  const navigate = useNavigate();
  const { user } = useUser();
  useEffect(() => {
    if (user && user.userOrganisation.length > 0) {
      if (!user.firstName || !user.lastName) {
        navigate("/account-settings",{state:{ edit: true }});
      }
      navigate("/projects",{state:{ showVideo: true }});
    }
  }, []);
  // const { t } = useTranslation();
  return (
    <>
      {!user && <Loader className="absolute top-0 left-0 -translate-x-1/2 -translate-y-1/2" />}
      <div className={`w-full h-full overflow-auto py-5`}>
        <div className="px-5  gap-5 h-full ">
          <div className="lg:flex justify-between gap-x-5 w-full">
            {user && user.userOrganisation.length > 0 ? (
              <></>
            ) : (
              <>
                {/* <div className="flex gap-2 items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
                  <div className="relative w-40 h-8 bg-primary-500 organizationStep organizationStepActive flex justify-center items-center text-base font-bold leading-3 text-white  tracking-wider">
                    {t("step")} 1
                  </div>
                  <div className="relative w-40 h-8 bg-gray-450 organizationStep flex justify-center items-center text-base font-bold leading-3 text-white  tracking-wider">
                    {t("step")} 2
                  </div>
                </div> */}
                {/* <div>
                  <span className="text-gray-400 text-2xl lg:text-3xl  font-medium font-['Poppins']">
                    Don't have any organisation yet?
                    <br />
                  </span>
                  <span className="text-neutral-600  text-3xl lg:text-5xl font-bold">
                    Create One!
                  </span>
                </div>
                <div className="flex items-center mt-3 ">
                  <button
                    onClick={() => setOrganisationForm(true)}
                    className="w-full mt-3 tracking-wide lg:mt-0 lg:w-fit bg-warning hover:bg-opacity-80 text-lg font-medium text-orange-800 py-3 px-7 rounded-md gap-4"
                  >
                    Create
                  </button>
                </div> */}
              </>
            )}
          </div>
          <OrganisationForm />

          {/* <div className="p-6">
            <img src={organisationImage} className="w-96" />
          </div> */}
        </div>
      </div>
    </>
  );
}

export default Organisation;
